/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export const userAccount = {
  loginForm: {
    title: 'Iniciar sesión',
    forgotPassword: '¿Has olvidado tu contraseña?',
    signIn: 'Inicia sesión',
    register: 'Registro',
    dontHaveAccount: '¿No tienes una cuenta?',
    guestCheckout: 'Pago como invitado',
    emailAddress: {
      label: 'Dirección de correo electrónico',
      placeholder: 'Ingrese el correo electrónico',
    },
    password: {
      label: 'Contraseña',
      placeholder: 'Contraseña',
    },
    wrongEmailFormat: 'Este no es un formato de correo electrónico válido.',
  },
  miniLogin: {
    userGreeting: 'Hola, {{name}}',
    signInRegister: 'Inicia sesión',
  },
};
